define(function (require) {
    var $ = require("jquery");
    var geocoder = require("@modules/tools/geocoder");
    var utility = require("@modules/tools/helpfulToolUtility");
    var apiUrl = window.scan && window.scan.apiUrl ? window.scan.apiUrl : "";

    var mapper;

    return {
        /**
         * Returns a jQuery promise for the provider search results.
         *
         * @param {} parameters Object of search parameters.
         * @returns {} Object with CurrentResults array, TotalResults integer, Facets array.
         */
        getResults: function (parameters) {
            return geocoder.geocode(parameters.zipOrAddress).then(function (coordinates) {
                if (!coordinates && parameters.zipOrAddress) {
                    var deferred = $.Deferred();
                    deferred.resolve({
                        TotalResults: 0,
                        CurrentResults: [],
                        Facets: {
                            PharmacyType: [],
                            Language: [],
                            Radius: utility.mapFacets(window.scan.emptyRadiusOptions)
                        }
                    });
                    return deferred.promise();
                }

                if (coordinates) {
                    parameters.latitude = coordinates.lat;
                    parameters.longitude = coordinates.lng;
                }

                return $.getJSON(apiUrl + "/api/pharmacysearch/results", parameters, null, "json").then(function (results) {
                    // we need to return the lat/lng of the point we searched against, if any.
                    if (coordinates) {
                        results.latitude = coordinates.lat;
                        results.longitude = coordinates.lng;
                    }

                    mapper = window.scan.pharmacyDetailsMap;

                    results.Facets.Radius = utility.mapFacets(results.Facets.Radius);
                    results.Facets.PharmacyType = utility.mapFacets(results.Facets.PharmacyType);
                    results.Facets.Language = utility.mapFacets(results.Facets.SpokenLanguages);
                    // results.Facets.PharmacyDetails = utility.mapFacets(results.Facets.PharmacyDetails);
                    var tmpDetails = utility.mapFacets(results.Facets.PharmacyDetails);
                    results.Facets.PharmacyDetails = utility.mapProperty(tmpDetails, mapper, "name", "text", true);

                    return results;
                });
            });
        },
        getCounties: function (parameters) {
            if (!parameters.year || !parameters.state) {
                const deferred = $.Deferred();
                deferred.resolve(null);
                return deferred.promise();
            }

            // console.log("pharmacyService: getting Counties");
            return $.getJSON(apiUrl + "/api/planfinderapi/counties", parameters, null, "json").then(function (results) {
                return Array.isArray(results) ? results : JSON.parse(results);
            });
        },
        getPlans: function (parameters) {
            if (!parameters.year || !parameters.state || !parameters.county) {
                const deferred = $.Deferred();
                deferred.resolve(null);
                return deferred.promise();
            }

            // console.log("pharmacyService: getting Plans");
            return $.getJSON(apiUrl + "/api/planfinderapi/getplans", parameters, null, "json").then(function (results) {
                return Array.isArray(results) ? results : JSON.parse(results);
            });
        }
    };
});
